import React from 'react';

function Footer() {
  return <div style={{padding: '1rem'}}>
      Soccer United FC&copy; 2022. All rights preserves.
  </div>;
}

export default Footer;

